export enum TokenTypes {
  ID = 'id',
  REFRESH = 'refresh',
  ACCESS = 'access',
  RESTRICTED = 'restricted',
}

export interface ITokens {
  restricted?: string;
  access?: string;
  id?: string;
  refresh?: string;
  readonly expiresIn?: number;
}

export interface ITokenStore {
  restricted?: string;
  access?: string;
  id?: string;
  refresh?: string;

  environment?: string;
  updateTokens(tokens: ITokens): void;
  // TODO stop using any here
  clear(tokensToClear?: TokenTypes[]): Promise<any>;
}
